import React from 'react';
import PropTypes from 'prop-types';
import { A } from 'components/Typography';
import BaseModal from 'products/nomad_insurance/components/BaseModal';
import usePolicyLink from 'products/nomad_insurance/hooks/usePolicyLink';
import { MediumText } from '../../styled';

const AdventureSportsModal = ({ isOpen, onClose }) => {
  const policyLink = usePolicyLink();
  const splitLink = policyLink.split('?');

  const getSearchLink = (searchStr) => {
    const params = new URLSearchParams(splitLink[1]);
    params.append('search', searchStr);
    return `${splitLink[0]}?${params.toString()}`;
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      heading="Adventure sports add-on details"
    >
      <div>
        Extends list of covered sports to include activities like kite-surfing,
        parachuting, paragliding, skydiving, scuba diving and more up to $100,000.{' '}
        <MediumText>
          <A href={getSearchLink('adventure sports')}>Read full list here</A>
        </MediumText>
      </div>
      <div>
        You are still not covered for professional, organized or rewarded sports, or for
        expeditions, and you are still required to ensure your safety.
      </div>
    </BaseModal>
  );
};

AdventureSportsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default AdventureSportsModal;
